import { type InitFlowComponent, isPwaMode, SettingsSchema, skipPwaScreenAtom, useSettings } from '@capsicum/common';
import { useAtomValue } from 'jotai';
import { useEffect, useMemo } from 'react';
import { browserName, isMobile, osName } from 'react-device-detect';

import { AndroidDeviceCTA } from '../AndroidDeviceCTA';
import { AppleDeviceCTA } from '../AppleDeviceCTA';

const CTAComponents = {
	android: AndroidDeviceCTA,
	ios: AppleDeviceCTA
};

const platform = osName.toLocaleLowerCase() as 'android' | 'ios';

const PWAForceInstallFlow: InitFlowComponent = ({ fallback, next }) => {
	const { areSettingsLoading, settings } = useSettings();
	const isPWAScreenSkipped = useAtomValue(skipPwaScreenAtom);
	const { pwaForceInstall } = settings ?? SettingsSchema.parse({});

	const isInstructionsVisible = useMemo(() => {
		const authorizedBrowsers = pwaForceInstall[platform];
		const unifiedBrowserName = browserName.toLocaleLowerCase().replace('mobile', '').trim();

		return (
			isMobile &&
			!isPwaMode() &&
			authorizedBrowsers.includes(unifiedBrowserName) &&
			!isPWAScreenSkipped &&
			!areSettingsLoading
		);
	}, [pwaForceInstall, isPWAScreenSkipped, areSettingsLoading]);

	useEffect(() => {
		if (!isInstructionsVisible && !areSettingsLoading) {
			next();
		}
	}, [isInstructionsVisible, areSettingsLoading]);

	if (isInstructionsVisible && !areSettingsLoading) {
		const CTAComponent = CTAComponents[platform];

		return <CTAComponent />;
	}

	return fallback;
};

PWAForceInstallFlow.keepAlive = true;

export default PWAForceInstallFlow;
